(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["looshi-anatomy"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAll() {
    document.querySelectorAll('.looshi-anatomy-section').forEach(function (sectionEl) {
      var root = sectionEl.querySelector('.lan');
      var diagram = sectionEl.querySelector('[data-lan]');
      if (!root || !diagram || diagram.hasAttribute('data-lan-ready')) return;
      diagram.setAttribute('data-lan-ready', '');
      var stage = diagram.querySelector('.lan__stage');
      var svg = diagram.querySelector('.lan__leaders');
      var marks = Array.prototype.slice.call(diagram.querySelectorAll('[data-lan-mark]'));
      var notes = Array.prototype.slice.call(diagram.querySelectorAll('[data-lan-note]'));
      var NS = 'http://www.w3.org/2000/svg';

      function draw() {
        if (!svg || !stage || window.innerWidth <= 750) { if (svg) svg.innerHTML = ''; return; }
        var d = diagram.getBoundingClientRect();
        svg.setAttribute('width', d.width); svg.setAttribute('height', d.height);
        svg.setAttribute('viewBox', '0 0 ' + d.width + ' ' + d.height);
        svg.innerHTML = '';
        var stageR = stage.getBoundingClientRect();
        marks.forEach(function (m, i) {
          var note = notes[i]; if (!note) return;
          var mr = m.getBoundingClientRect(); var nr = note.getBoundingClientRect();
          var mx = mr.left - d.left, my = mr.top - d.top;
          var nx = nr.left - d.left + nr.width / 2, ny = nr.top - d.top;
          var ring = parseFloat(getComputedStyle(m.querySelector('.lan__ring')).width) / 2 || 20;
          var startY = my + ring + 2;
          var busY = (stageR.bottom - d.top) + 18 + i * 12;
          var path = document.createElementNS(NS, 'path');
          var dstr = Math.abs(mx - nx) < 4
            ? 'M' + mx + ' ' + startY + ' V' + ny
            : 'M' + mx + ' ' + startY + ' V' + busY + ' H' + nx + ' V' + ny;
          path.setAttribute('d', dstr); path.setAttribute('data-n', String(i + 1));
          svg.appendChild(path);
          var len = path.getTotalLength();
          path.setAttribute('data-len', ''); path.style.setProperty('--len', len); path.style.setProperty('--i', i);
          var dot = document.createElementNS(NS, 'circle');
          dot.setAttribute('cx', nx); dot.setAttribute('cy', ny); dot.setAttribute('r', 2.5);
          svg.appendChild(dot);
        });
      }
      function reveal() { root.classList.add('is-on'); }

      draw();
      var img = stage.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', draw);
      window.addEventListener('resize', function () { clearTimeout(diagram._t); diagram._t = setTimeout(draw, 120); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(draw);

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { draw(); reveal(); io.disconnect(); } }, { threshold: 0.35 });
        io.observe(diagram);
      } else { reveal(); }

      notes.forEach(function (n) {
        var set = function () { diagram.setAttribute('data-hot', n.getAttribute('data-lan-note')); };
        var clear = function () { diagram.setAttribute('data-hot', ''); };
        n.addEventListener('mouseenter', set); n.addEventListener('mouseleave', clear);
        n.addEventListener('focus', set); n.addEventListener('blur', clear);
      });
      diagram.setAttribute('data-hot', '');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["looshi-make-room-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.currentScript && document.currentScript.closest('[data-lmr]');
  var sections = root ? [root] : document.querySelectorAll('[data-lmr]');
  sections.forEach(function (el) {
    if (el.dataset.lmrInit) return;
    el.dataset.lmrInit = '1';
    var texts = el.querySelectorAll('[data-lmr-text]');
    if (texts.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var imgs = {};
    el.querySelectorAll('[data-lmr-img]').forEach(function (im) { imgs[im.dataset.lmrImg] = im; });
    var interval = parseInt(el.dataset.interval, 10) || 3500;
    var i = 0;
    setInterval(function () {
      texts[i].classList.remove('is-on');
      i = (i + 1) % texts.length;
      texts[i].classList.add('is-on');
      var want = texts[i].hasAttribute('data-has-image') ? String(i) : 'base';
      Object.keys(imgs).forEach(function (k) {
        imgs[k].classList.toggle('is-on', k === want && imgs[want] !== undefined);
      });
      if (!imgs[want] && imgs['base']) imgs['base'].classList.add('is-on');
    }, interval);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["looshi-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  // A Judge.me review request lands on this page carrying judgeme_token. The review
  // widget is the section below this one, and it is collapsed by default, so that
  // visitor would land on a page with no way to leave a review. On those visits it
  // starts open; snippets/looshi-review-link.liquid does the scrolling, site wide.
  function isReviewVisit() {
    return /[?&](judgeme_token|judgeme_review_source)=/.test(window.location.search) ||
      window.location.hash === '#judgeme_product_reviews';
  }

  function init() {
    document.querySelectorAll('.looshi-proof-section').forEach(function (sectionEl) {
      var btn = sectionEl.querySelector('[data-lpf-toggle]');
      if (!btn || btn.hasAttribute('data-lpf-ready')) return;
      btn.setAttribute('data-lpf-ready', '');
      var next = sectionEl.nextElementSibling;
      var widget = next && next.classList.contains('shopify-section') && next.querySelector('.jdgm-rev-widg, .jdgm-widget') ? next : null;
      if (!widget) return;
      var count = (btn.textContent.match(/\((\d+)\)/) || [])[1];
      var open = isReviewVisit();
      widget.classList.toggle('lpf-collapsed', !open);
      btn.hidden = false;
      function label() {
        btn.textContent = (open ? btn.getAttribute('data-label-close') : btn.getAttribute('data-label-open')) + (open || !count ? '' : ' (' + count + ')');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      if (open) label();
      btn.addEventListener('click', function () {
        open = !open;
        widget.classList.toggle('lpf-collapsed', !open);
        label();
        if (open) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["looshi-wholesale-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-lwo]');
  if (!root || !root.querySelector('[data-row]')) return;
  var minimumCents = (parseInt(root.dataset.minimum, 10) || 0) * 100;
  var button = root.querySelector('[data-checkout]');
  var status = root.querySelector('[data-status]');
  var minNote = root.querySelector('[data-min-note]');

  function money(cents) {
    var dollars = cents / 100;
    var hasCents = Math.round(cents) % 100 !== 0;
    return '$' + dollars.toLocaleString('en-US', { minimumFractionDigits: hasCents ? 2 : 0, maximumFractionDigits: 2 });
  }

  var linesEl = root.querySelector('[data-lines]');
  var bar = root.querySelector('[data-bar]');
  var barTotal = root.querySelector('[data-bar-total]');
  var barNote = root.querySelector('[data-bar-note]');
  var barButton = root.querySelector('[data-bar-checkout]');

  function rowName(row) {
    var el = row.querySelector('.lwo__name');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function read() {
    var items = [];
    var lines = [];
    var sums = { boxes: 0, testers: 0, samples: 0, holders: 0, total: 0, retail: 0 };
    root.querySelectorAll('[data-row]').forEach(function (row) {
      var price = parseInt(row.dataset.price, 10) || 0;
      var retail = parseInt(row.dataset.retail, 10) || price;
      var name = rowName(row);
      if (row.dataset.kind === 'box') {
        var caseSize = parseInt(row.dataset.case, 10) || parseInt(root.dataset.case, 10) || 3;
        var casesInput = row.querySelector('[data-qty="cases"]');
        var cases = Math.max(0, parseInt(casesInput.value, 10) || 0);
        casesInput.value = cases;
        var boxes = cases * caseSize;
        row.querySelector('[data-boxes]').textContent = boxes + (boxes === 1 ? ' box' : ' boxes');
        if (boxes > 0) {
          items.push({ id: parseInt(row.dataset.variant, 10), quantity: boxes });
          sums.boxes += boxes; sums.total += boxes * price; sums.retail += boxes * retail;
          lines.push({ label: name + ' · ' + cases + (cases === 1 ? ' case (' : ' cases (') + boxes + ' boxes)', cents: boxes * price });
        }
        var tester = row.querySelector('[data-tester]');
        if (tester) {
          tester.disabled = boxes === 0;
          if (boxes === 0) tester.checked = false;
          if (tester.checked) {
            var testerCents = parseInt(row.dataset.testerPrice, 10) || 0;
            items.push({ id: parseInt(row.dataset.testerVariant, 10), quantity: 1 });
            sums.testers += 1; sums.total += testerCents;
            lines.push({ label: name + ' tester', cents: testerCents, sub: true });
          }
        }
        var samples = row.querySelector('[data-qty="samples"]');
        if (samples) {
          var q = Math.max(0, parseInt(samples.value, 10) || 0);
          samples.value = q;
          if (q > 0) {
            var sampleCents = q * (parseInt(row.dataset.samplePrice, 10) || 0);
            items.push({ id: parseInt(row.dataset.sampleVariant, 10), quantity: q });
            sums.samples += q; sums.total += sampleCents;
            lines.push({ label: name + ' sample sticks × ' + q, cents: sampleCents, sub: true });
          }
        }
      } else {
        var unitsInput = row.querySelector('[data-qty="units"]');
        var units = Math.max(0, parseInt(unitsInput.value, 10) || 0);
        unitsInput.value = units;
        if (units > 0) {
          items.push({ id: parseInt(row.dataset.variant, 10), quantity: units });
          sums.holders += units; sums.total += units * price; sums.retail += units * retail;
          lines.push({ label: name + ' × ' + units, cents: units * price });
        }
      }
    });
    return { items: items, lines: lines, sums: sums };
  }

  function renderLines(lines) {
    if (!linesEl) return;
    linesEl.textContent = '';
    if (!lines.length) {
      var empty = document.createElement('li');
      empty.className = 'lwo__line lwo__line--empty';
      empty.textContent = 'Nothing added yet.';
      linesEl.appendChild(empty);
      return;
    }
    lines.forEach(function (line) {
      var li = document.createElement('li');
      li.className = 'lwo__line' + (line.sub ? ' lwo__line--sub' : '');
      var label = document.createElement('span');
      label.textContent = line.label;
      var amount = document.createElement('span');
      amount.className = 'lwo__line-amount';
      amount.textContent = money(line.cents);
      li.appendChild(label); li.appendChild(amount);
      linesEl.appendChild(li);
    });
  }

  function render() {
    var state = read();
    renderLines(state.lines);
    root.querySelector('[data-sum="boxes"]').textContent = state.sums.boxes;
    root.querySelector('[data-sum="total"]').textContent = money(state.sums.total);
    root.querySelector('[data-sum="retail"]').textContent = money(state.sums.retail);
    var met = state.items.length > 0 && state.sums.total >= minimumCents;
    button.disabled = !met;
    if (barButton) barButton.disabled = !met;
    if (barTotal) barTotal.textContent = money(state.sums.total);
    var noteText = 'Minimum order ' + money(minimumCents);
    if (minimumCents > 0) {
      if (met) {
        noteText = 'Minimum of ' + money(minimumCents) + ' met';
        minNote.classList.add('is-met');
      } else {
        noteText = money(minimumCents - state.sums.total) + ' more to reach the ' + money(minimumCents) + ' minimum';
        minNote.classList.remove('is-met');
      }
      minNote.textContent = noteText;
    }
    if (barNote) barNote.textContent = noteText;
    return state;
  }

  if (barButton) barButton.addEventListener('click', function () { button.click(); });

  root.addEventListener('click', function (event) {
    var step = event.target.closest('[data-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.step, 10));
    render();
  });
  root.addEventListener('input', render);
  root.addEventListener('change', render);

  // Every variant the sheet knows about, so the cart call can set each one to the sheet's number (including zero)
  function sheetVariants() {
    var ids = [];
    root.querySelectorAll('[data-row]').forEach(function (row) {
      ['variant', 'testerVariant', 'sampleVariant'].forEach(function (key) {
        if (row.dataset[key]) ids.push(parseInt(row.dataset[key], 10));
      });
    });
    return ids;
  }

  // The sheet starts from what is already in the cart, so it edits the order rather than replacing it
  function prefill(cart) {
    var byVariant = {};
    (cart.items || []).forEach(function (item) { byVariant[item.variant_id] = (byVariant[item.variant_id] || 0) + item.quantity; });
    root.querySelectorAll('[data-row]').forEach(function (row) {
      var boxes = byVariant[parseInt(row.dataset.variant, 10)] || 0;
      if (row.dataset.kind === 'box') {
        var caseSize = parseInt(row.dataset.case, 10) || parseInt(root.dataset.case, 10) || 3;
        row.querySelector('[data-qty="cases"]').value = Math.floor(boxes / caseSize);
        var tester = row.querySelector('[data-tester]');
        if (tester && row.dataset.testerVariant) tester.checked = (byVariant[parseInt(row.dataset.testerVariant, 10)] || 0) > 0;
        var samples = row.querySelector('[data-qty="samples"]');
        if (samples && row.dataset.sampleVariant) samples.value = byVariant[parseInt(row.dataset.sampleVariant, 10)] || 0;
      } else {
        row.querySelector('[data-qty="units"]').value = boxes;
      }
    });
    render();
  }

  button.addEventListener('click', function () {
    var state = render();
    if (!state.items.length) return;
    button.disabled = true;
    status.classList.remove('is-error');
    status.textContent = 'Building your order';
    // One update call sets the sheet's variants to the sheet's numbers and leaves anything else in the cart alone
    var updates = {};
    sheetVariants().forEach(function (id) { updates[id] = 0; });
    state.items.forEach(function (item) { updates[item.id] = item.quantity; });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) {
        if (response.ok) { window.location.href = '/checkout'; return; }
        return response.json().catch(function () { return {}; }).then(function (error) {
          throw new Error(error.description || error.message || 'The order could not be added. Please try again.');
        });
      })
      .catch(function (error) {
        status.classList.add('is-error');
        status.textContent = error.message;
        button.disabled = false;
      });
  });

  render();
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (response) { return response.ok ? response.json() : null; })
    .then(function (cart) { if (cart) prefill(cart); })
    .catch(function () {});
})();

  } catch(e) { console.error(e); }
})();
})();
